const url = "/admin";

export const RouterPrivateName = {
  HomePage: {
    url: `${url}/home`,
  },
  Product: {
    List: {
      url: `${url}/products/list`,
    },
    Create: {
      url: `${url}/products/create`,
    },
    Update: {
      url: `${url}/products/update`,
    },
  },
  Category: {
    List: {
      url: `${url}/categories/list`,
    },
    Create: {
      url: `${url}/categories/create`,
    },
  },
  Cart: {
    List: {
      url: `${url}/carts/list`,
    },
  },
  Sale: {
    List: { url: `${url}/sales/list` },
  },
};
